<template lang="html">
  <div>
    <ul class="lista-downloads" v-for="cadeia in cadeias">

      <li class="prod">Certificado da <span v-if="nomeac != 'ACT SOLUTI'">AC</span> {{ nomeac }}
        <em v-if="cadeia.descricao" style="font-size: small">
          <br>{{ cadeia.descricao }}
        </em>
      </li>

      <li v-for="certificado in cadeia.certificados">
        <a :href="certificado.arquivo">Certificado da <span v-if="nomeac != 'ACT SOLUTI'">AC</span> {{ certificado.nome }}</a>
        <span>Apenas um certificado no arquivo.</span>
      </li>

      <template v-if="cadeia.p7b">
        <li class="prod">Cadeia de Certificação <span v-if="nomeac != 'ACT SOLUTI'">AC</span> {{ nomeac }}
          <em v-if="cadeia.descricao" style="font-size: small">
            <br>{{ cadeia.descricao }}
          </em>
        </li>

        <li v-if="cadeia.p7b.pem">
          <a :href="cadeia.p7b.pem">Cadeia de Certificação <span v-if="nomeac != 'ACT SOLUTI'">AC</span> {{ nomeac }} - P7B PEM</a>
          <span>Toda a cadeia em um único arquivo.</span>
        </li>

        <li v-if="cadeia.p7b.der">
          <a :href="cadeia.p7b.der">Cadeia de Certificação <span v-if="nomeac != 'ACT SOLUTI'">AC</span> {{ nomeac }} - P7B DER</a>
          <span>Toda a cadeia em um único arquivo.</span>
        </li>
      </template>

      <template v-if="cadeia.lcr">
        <li class="prod">LCR - Lista de Certificados Revogados
          <em v-if="cadeia.descricao" style="font-size: small">
            <br>{{ cadeia.descricao }}
          </em>
        </li>

        <li v-for="(lcr,index) in cadeia.lcr">
          <a :href="lcr.link">LCR {{ lcr.nome }}</a>
          <span >&nbsp;</span>
        </li>
      </template>

    </ul>
  </div>
</template>

<script>
export default {
  props: [
    'nomeac', 'cadeias'
  ]
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// RepositorioCadeia.vue?ebd8d38e